import React, {forwardRef} from 'react'
import PropTypes from 'prop-types'
import {Box, defineStyle} from '@chakra-ui/react3'

const baseStyles = defineStyle({
    '& > *:not(style)': {
        overflow: 'hidden',
        position: 'absolute',
        inset: 0,
        width: '100%',
        height: '100%'
    },
    '& > img, & > video': {
        objectFit: 'cover'
    }
})

const AspectRatio = forwardRef(({ratio, children, ...rest}, ref) => {
    return (
        <Box
            aspectRatio={ratio}
            {...rest}
            ref={ref}
            position="relative"
            css={[baseStyles, rest.css]}
        >
            {children}
        </Box>
    )
})

AspectRatio.displayName = 'AspectRatio'

AspectRatio.propTypes = {
    children: PropTypes.node,
    ratio: PropTypes.oneOfType([PropTypes.number, PropTypes.object, PropTypes.string])
}

export default AspectRatio
